import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { completeGoogleLogin } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    completeGoogleLogin(sessionId)
      .then(() => {
        // Strip the hash and go home
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/', { replace: true });
      })
      .catch((err) => {
        setError(err.message || 'Google sign-in failed');
        setTimeout(() => navigate('/login', { replace: true }), 2500);
      });
  }, [completeGoogleLogin, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 text-white">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin mx-auto mb-3" />
        <div className="text-sm text-slate-400">{error || 'Signing you in…'}</div>
      </div>
    </div>
  );
}
